@if (!showDetails) {
  <td class="py-2 pe-2" style="max-width: 60px;">
    @if (orderLine.image) {
      <app-article-image class="w-100 d-inline-block" [imageUrl]="orderLine.image" [ngbTooltip]="tipContent">
      </app-article-image>
    }
    @if (!orderLine.image) {
      <br>
      }
      <ng-template #tipContent
        > @if (orderLine.image) {
        <app-article-image class="w-100 d-inline-block" [imageUrl]="orderLine.image">
        </app-article-image>
        }</ng-template
        >
      </td>
      <td class="py-2" [ngClass]="applicationService.getSelectCompanyGroupCode() !== 'WG' ? 'clickable withOpacity' : ''"
        (click)="applicationService.getSelectCompanyGroupCode() !== 'WG' ? editOrder(orderLine) : null">
        <span class="description fw-medium" [innerHTML]="orderLine.article_description"></span><br />
        @if (applicationService.getSelectCompanyGroupCode() !== 'WG') {
          {{orderLine.article_code}}
        }
        @if (applicationService.getSelectCompanyGroupCode() === 'WG') {
          <span [articleQuickView]="orderLine.article_code">{{orderLine.article_code}}</span>
        }
        @if (orderLine.ean_code) {
          <small class="d-block">EAN: {{orderLine.ean_code}}</small>
        }
      </td>
      @if (applicationService.getSelectCompanyGroupCode() === 'WG') {
        <td class="py-2 text-nowrap">
          {{orderLine.brand_name}}
        </td>
      }
      <td class="py-2 text-end text-nowrap">
        {{ 'QTY_ORDERED' | translate }}: {{orderLine.quantity}} <br />
        @if (applicationService.getSelectCompanyGroupCode() !== 'LAP') {
          <small>{{ 'NUMBER_TO_SEND' | translate }}: {{orderLine.quantity_to_send}}</small>
        }
      </td>
      <td class="py-2 text-end text-nowrap">
        {{ 'NUMBER_IN_TRANSIT' | translate }}: {{orderLine.quantity_in_transit}}<br />
        @if (applicationService.getSelectCompanyGroupCode() !== 'LAP') {
          <small>{{ 'QUANTITY_PROCESSED' | translate }}: {{orderLine.quantity_delivered}} </small>
        }
      </td>
      <td class="py-2">
        @if (orderLine.erp_id && applicationService.getSelectCompanyGroupCode() === 'WG') {
          {{'ORDER_NUMBER' | translate}}: <b class="clickable withOpacity" (click)="downloadOpenOrder()">
          <i class="material-icons text-primary clickable withOpacity"
            style="font-size: 16px; transform: translateY(2px);">
            picture_as_pdf
          </i>
        {{orderLine.erp_id}}</b>
      }
      @if (applicationService.getSelectCompanyGroupCode() !== 'WG') {
        {{orderLine.erp_id}}<br />
      }
      <small>{{orderLine.accentry_id}}</small>
    </td>
    @if (applicationService.getSelectCompanyGroupCode() !== 'LAP' && applicationService.getSelectCompanyGroupCode() !== 'GHO') {
      <td class="py-2 reference">
        @if (applicationService.getSelectCompanyGroupCode() !== 'WG') {
          <span>{{orderLine.order_reference}}</span>
        }
        @if (applicationService.getSelectCompanyGroupCode() === 'WG' && orderLine.line_id !== '-') {
          <span>{{orderLine.line_id}}<br/></span>
        }
        @if (applicationService.getSelectCompanyGroupCode() === 'WG') {
          <span class="d-block">{{orderLine.remark}}</span>
        }
      </td>
    }
    @if (applicationService.getSelectCompanyGroupCode() === 'WG') {
      <td>
        @if (!orderLine.pre_order) {
          <span> </span>
        }
        @if (orderLine.pre_order) {
          <span class="badge bg-dark">{{"PREORDER"|translate}}</span>
        }
      </td>
    }
    <td class="py-2">
      <app-nett-price [price]="{value: orderLine.netto_price, currency: ''}"></app-nett-price><br />
      <small>
        @if (orderLine.consumer_price) {
          <app-retail-price [price]="{value: orderLine.consumer_price, currency: ''}">
          </app-retail-price>
        }
      </small>
    </td>
    @if (applicationService.getSelectCompanyGroupCode() !== 'WG') {
      <td class="py-2">
        <input type="text" [(ngModel)]="orderLine.remark" name="remark" class="form-control form-control-sm" [disabled]="applicationService.getSelectCompanyGroupCode() === 'LAP'"
          (change)="inlineEditOrder()">
      </td>
    }
    @if (applicationService.getSelectCompanyGroupCode() !== 'WG') {
      <td class="py-2 clickable withOpacity">
        <div class="form-check form-switch">
          <input type="checkbox" class="form-check-input" id="toggle_sold_{{orderLine.line_id}}" name="sold"
            [(ngModel)]="orderLine.sold" (change)="inlineEditOrder()">
          <label class="form-check-label justify-content-end text-light"
          for="toggle_sold_{{orderLine.line_id}}"></label>
        </div>
      </td>
    }
    <td style="min-width: 100px" class="py-2">
      @if (orderLine.desired_delivery_week) {
        {{'DESIRED_WEEK' | translate }}: {{orderLine.desired_delivery_week}}<br />
      }
      <span>{{'DELIVERY_WEEK' | translate }}: {{orderLine.delivery_week_or_date!=='DATE_UNKNOWN'?orderLine.delivery_week_or_date:'DATE_UNKNOWN'|translate}}
        @if (orderLine.old_delivery_week && showOldDeliveryWeek) {
          ({{ 'WAS' | translate }}: {{orderLine.old_delivery_week}})
        }
      </span>
      <i class="d-block material-icons text-primary clickable withOpacity opacity-50 me-2"   placement="top" [ngbTooltip]="orderLine | shippingAddressText" triggers="click:blur" placement="left">
        local_shipping
      </i>
    </td>
    <td class="py-2">
      @if (((orderLine.backward_shifting_status < 3 && orderLine.backward_shifting_weeks) || orderLine.can_push_fordward_delivery_week) && applicationService.getSelectCompanyGroupCode() !== 'WG' && !orderLine.disallow_backwards_shifting) {
        <i class="material-icons text-secondary clickable withOpacity" (click)="editOrder(orderLine)">
          swap_horiz
        </i>
        <i class="material-icons text-secondary clickable withOpacity" (click)="editOrder(orderLine)">
          calendar_today
        </i>
      }
    </td>
    @if (applicationService.getSelectCompanyGroupCode() !== 'WG' && applicationService.getSelectCompanyGroupCode() !== 'LAP') {
      <td class="py-2">
        <i class="material-icons text-primary clickable withOpacity" (click)="editOrder(orderLine)">
          edit
        </i>
      </td>
    }
  }
